/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Question16({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="16"
      role="img"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.368 6.453C5.39 4.793 6.425 3.8 8.133 3.8c1.428 0 2.5.938 2.5 2.177 0 1.07-.526 1.512-1.156 1.939a3.16 3.16 0 0 1-.127.086l-.09.06-.022.016c-.429.285-.713.475-.713.874v.133H7.16v-.217c0-.82.462-1.183 1.071-1.575l.077-.05c.497-.335.89-.601.89-1.19 0-.202-.085-.874-1.093-.874-.833 0-1.26.462-1.316 1.4l-.007.112-1.414-.14v-.098Zm3.374 3.857H7.048v1.645h1.694V10.31Z"
        fill={CssVars.textColor}
      />
      <path
        clipRule="evenodd"
        d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
